// @ts-nocheck
import { UPGRADE_REQUEST_ERROR, UPGRADE_REQUEST_LOADING, UPGRADE_REQUEST_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const upgrade_request = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: UPGRADE_REQUEST_LOADING,
                data: true
            })
            Authservices.upgrade_request(data).then((data) => {
                if (data?.status === 200) {
                    dispatch({
                        type: UPGRADE_REQUEST_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: UPGRADE_REQUEST_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}